
import { Options, Vue } from 'vue-class-component'
@Options({
  props: {
    type: { type: String, default: 'info' },
    size: { type: String, default: 'default' },
    color: { type: String },
    outline: { type: Boolean, default: false },
    icon: { type: String },
    responsive: Boolean,
    wide: Boolean,
    square: Boolean,
    circle: Boolean,
    loading: Boolean,
    disabled: Boolean
  }
})
export default class MyButton extends Vue {
}
